export enum ExpensesCatalogueColumnsEnum {
  Number = 'number',
  Name = 'description',
  Description = 'description2',
  Quantity = 'quantity',
  Unit = 'unit',
  Price = 'price',
}
